import { TablelistProApi } from '@lib/api'

import { User } from 'types/model'

class UserApi extends TablelistProApi<User> {
  constructor() {
    super('/user')
  }

  async me() {
    const response = await this.read('me')
    return response
  }

  async updateProfile(data: Partial<User>) {
    const response = await this.put<User>('/me', data)
    return response
  }
}

export const userApi = new UserApi()
